import type { Router } from 'vue-router'
import { createProgressGuard } from '@da-vinci/hooks'

import { createPermissionGuard } from './permissionGuard'

export function setupRouterGuard(router: Router) {
  createPermissionGuard(router)
  createProgressGuard(router)
  router.afterEach((to) => {
    const store = useStore()
    const first = store.route.history[0]
    if (!to.name) return
    if (first === to.name) return
    store.route.history.unshift(to.name)
  })
}
